module.exports = __webpack_public_path__ + "static/media/crf_sampling.2d2bb8eb.ipynb";